import React, { Fragment, useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { updateMass } from '../../../common/api';
import { toast } from 'react-toastify';
import { formatDate } from '../../../common/utils';

import '../modals.css';

const TaskReassign = ( { close, user, tids, pTeam } ) => {
    const [ assigned, setAssigned ] = useState();
    const [ ready, setReady ] = useState( false );
    const [ processing, setProcessing ] = useState( false );

    const handleUpdate = async () => {
        setProcessing( true );
        
        const updated = await updateMass( user.email, 'mass-tasks', tids, { assignedTo: assigned } );
        if ( updated.length ) {
            toast.success( `Tasks have been updated`, { theme: 'dark' } );
            close();
        } else {
            toast.error( `Tasks were not updated - please contact the Support Team`, { theme: 'dark' } );
            setProcessing( false );
        }
    }

    useEffect( () => {
        if ( assigned && assigned.length > 0 ) {
            setReady( true );
        } else {
            setReady( false );
        }
    }, [ assigned ] );

    useEffect( () => {
        if ( !ready ) {
            setAssigned( pTeam.find( p => p.default ).uid );
        }
    }, [ ready, pTeam ] );

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '600px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Re-Assign Selected Tasks To...</Col>
                </Row>
                {
                    processing ? (
                        <Fragment>
                            <Row className='py-3'>
                                <Col className='text-center'>
                                    <Spinner animation="border" variant='primary' role="status" />
                                </Col>
                            </Row>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Assign Them To</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={assigned} onChange={ ( e ) => setAssigned( e.target.value ) }>
                                            {
                                                pTeam.map( ( p, idx ) => <option key={idx} value={p.uid}>{p.name}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => handleUpdate() } disabled={!ready}>Update</Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                </Col>
                            </Row>
                        </Fragment>
                    )
                }
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    user: state.user,
    pTeam: state.user.lists.team
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( TaskReassign );